export { default as back } from '@/assets/icons/back.svg?react'
export { default as background1 } from '@/assets/icons/background-1.svg?react'
export { default as background2 } from '@/assets/icons/background-2.svg?react'
export { default as background3 } from '@/assets/icons/background-3.svg?react'
export { default as background4 } from '@/assets/icons/background-4.svg?react'
export { default as bowlFull } from '@/assets/icons/bowl_full.svg?react'
export { default as bubble1Background } from '@/assets/icons/bubble_1_background.svg?react'
export { default as bubble2Background } from '@/assets/icons/bubble_2_background.svg?react'
export { default as bubble3Background } from '@/assets/icons/bubble_3_background.svg?react'
export { default as buttonElement1 } from '@/assets/icons/button/element-1.svg?react'
export { default as buttonElement2 } from '@/assets/icons/button/element-2.svg?react'
export { default as buttonElement3 } from '@/assets/icons/button/element-3.svg?react'
export { default as caretUp } from '@/assets/icons/caret-up.svg?react'
export { default as checked } from '@/assets/icons/checked.svg?react'
export { default as checkedAlt } from '@/assets/icons/checked-alt.svg?react'
export { default as checkedRunner } from '@/assets/icons/checked-runner.svg?react'
export { default as choiceBad } from '@/assets/icons/choice/bad.svg?react'
export { default as choiceGood } from '@/assets/icons/choice/good.svg?react'
export { default as choiceNeutral } from '@/assets/icons/choice/neutral.svg?react'
export { default as circle } from '@/assets/icons/circle.svg?react'
export { default as close } from '@/assets/icons/close.svg?react'
export { default as clover } from '@/assets/icons/clover.svg?react'
export { default as diamond } from '@/assets/icons/diamond.svg?react'
export { default as doodle } from '@/assets/icons/doodle.svg?react'
export { default as dragBackgroundCursor } from '@/assets/icons/drag-background-cursor.svg?react'
export { default as dragCenterCursor } from '@/assets/icons/drag-center-cursor.svg?react'
export { default as dragLeftCursor } from '@/assets/icons/drag-left-cursor.svg?react'
export { default as dragRightCursor } from '@/assets/icons/drag-right-cursor.svg?react'
export { default as explosion } from '@/assets/icons/explosion.svg?react'
export { default as eye } from '@/assets/icons/eye.svg?react'
export { default as eyeAlt } from '@/assets/icons/eye-alt.svg?react'
export { default as failed } from '@/assets/icons/failed.svg?react'
export { default as freeze } from '@/assets/icons/freeze.svg?react'
export { default as journal } from '@/assets/icons/journal.svg?react'
export { default as legs } from '@/assets/icons/legs.svg?react'
export { default as logoBrand } from '@/assets/icons/logo-brand.svg?react'
export { default as mathClass } from '@/assets/icons/math_class.svg?react'
export { default as next } from '@/assets/icons/next.svg?react'
export { default as pause } from '@/assets/icons/pause.svg?react'
export { default as pedroBrocoli } from '@/assets/icons/pedro-brocoli.svg?react'
export { default as pedroBubble } from '@/assets/icons/pedro-bubble.svg?react'
export { default as pedroNarnia } from '@/assets/icons/pedro-narnia.svg?react'
export { default as play } from '@/assets/icons/play.svg?react'
export { default as pomme } from '@/assets/icons/pomme.svg?react'
export { default as previous } from '@/assets/icons/previous.svg?react'
export { default as range1 } from '@/assets/icons/range/range-1.svg?react'
export { default as range2 } from '@/assets/icons/range/range-2.svg?react'
export { default as range3 } from '@/assets/icons/range/range-3.svg?react'
export { default as range4 } from '@/assets/icons/range/range-4.svg?react'
export { default as range5 } from '@/assets/icons/range/range-5.svg?react'
export { default as receipt } from '@/assets/icons/receipt.svg?react'
export { default as soundOff } from '@/assets/icons/sound-off.svg?react'
export { default as soundOn } from '@/assets/icons/sound-on.svg?react'
export { default as magnifyingGlass } from '@/assets/icons/stickers/magnifying-glass.svg?react'
export { default as swirl } from '@/assets/icons/swirl.svg?react'
export { default as triangle } from '@/assets/icons/triangle.svg?react'
